<template>
  <div
    id="monaco-editor"
    ref="editorRef"
    :class="bem.b()"
    :style="{
      width: props.width,
      height: props.height,
    }"
  />
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import {
  codeEditorEmits,
  codeEditorProps,
  codeThemeList,
  defaultOptions,
} from './config'

import loader from '@monaco-editor/loader'

defineOptions({ name: 'LlCodeEditor' })

const props = defineProps(codeEditorProps)
const emits = defineEmits(codeEditorEmits)
const bem = createNamespace('code-editor')

let monaco: any
let editor: any

const editorRef = ref()
const initMonacoEditor = async () => {
  loader.config({ 'vs/nls': { availableLanguages: { '*': 'zh-cn' } } })
  monaco = await loader.init()
  monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
    noSemanticValidation: true,
    noSyntaxValidation: false,
  })
  monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
    target: monaco.languages.typescript.ScriptTarget.ES2020,
    allowNonTsExtensions: true,
  })

  editor = monaco.editor.create(editorRef.value, {
    value: props.value,
    language: props.language,
    theme: props.theme,
    ...defaultOptions,
    ...props.options,
    readOnly: props.disabled,
  })
  // 监听值的变化
  editor.onDidChangeModelContent(() => {
    const value = editor.getValue() //给父组件实时返回最新文本
    emits('update:value', value)
    emits('change', value)
  })
  handleChangeTheme(props.theme)

  emits('editor-mounted', editor)
}
const handleChangeTheme = async (theme: string) => {
  const find = codeThemeList.find((item) => item.value === theme)
  if (find) {
    const themeData = {
      ...find.data,
    }
    try {
      monaco.editor.defineTheme(theme, themeData)
      monaco.editor.setTheme(theme)
    } catch (error) {
      monaco.editor.setTheme('vs')
    }
  } else {
    monaco.editor.setTheme('vs')
  }
}
watch(
  () => props.value,
  (newValue) => {
    if (editor) {
      const value = editor.getValue()
      if (newValue !== value) {
        editor.setValue(newValue)
      }
    }
  }
)

watch(
  () => props.options,
  (newValue) => {
    editor.updateOptions(newValue)
  },
  { deep: true }
)

watch(
  () => props.language,
  (newValue) => {
    monaco.editor.setModelLanguage(editor.getModel()!, newValue)
  }
)

defineExpose({
  getEditor() {
    return editor
  },
})

onBeforeUnmount(() => {
  editor.dispose()
})

onMounted(async () => {
  await initMonacoEditor()
})
</script>
